import { useState } from 'react';

const usePriceField = () => {
  const [priceString, setPrice] = useState('');
  const [recurrenceString, setRecurrence] = useState('');
  const price = parseFloat(priceString.replace(',', '.'));
  const recurrence = parseFloat(recurrenceString.replace(',', '.')) || 1;

  return {
    price, recurrence, setPrice, setRecurrence,
  };
};

export default usePriceField;
